//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  OnDestroy,
  untracked
} from "@angular/core";

//local imports
import {
  CloseDialogMessage,
  CommandModel,
  Messenger
} from "@app/shared";

import {
  ProjectDetails,
  ProjectHttpService,
  ProjectModel,
  ProgramModel,
  UpdateProjectRequest
} from "@app/catalog";

import {
  ProgramNotFoundFault,
  ProgramNotFoundMessage,
  ProjectAlreadyExistsFault,
  ProjectAlreadyExistsMessage,
  ProjectNotFoundFault,
  ProjectNotFoundMessage,
} from "@app/catalog-common";

import {
  ToastLevel,
  ToastMessage
} from "@app/components";

@Component({
  selector: "edit-project-form",
  templateUrl: "./edit-project-form.component.html",
  styleUrl: "./edit-project-form.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EditProjectFormComponent implements OnDestroy {
  public project = input.required<ProjectModel>();

  public programs = input.required<ProgramModel[]>();

  public details = computed(() =>
    ProjectDetails.fromProject(untracked(() => this.project().programId()), this.project()));

  public cancelCommand = new CommandModel({
    executeAction: () => {
      this.messenger.send(new CloseDialogMessage());
      return Promise.resolve();
    },
  });

  public submitCommand = new CommandModel({
    executeAction: () => this.save(),
    isValid: computed(() => this.details()?.isValid() ?? false),
  });

  constructor(
    private projectHttpService: ProjectHttpService,
    private messenger: Messenger,
  ) {}

  private save = async () => {
    let details = this.details();

    let request = new UpdateProjectRequest();
    request.programId = details.program.value();
    request.name = details.name.value();
    request.description = details.description.value();
    request.cap = details.capNumber.value();
    request.spa = details.spaFile();

    let updateResult = this.projectHttpService.update(this.project().id, request);

    try {
      await updateResult.response;
      this.messenger.send(new CloseDialogMessage());
    } catch (error) {
      if (error instanceof ProjectAlreadyExistsFault) {
        this.messenger.send(
          ToastMessage.create(
            new ProjectAlreadyExistsMessage(error.name),
            ToastLevel.Warning,
          ),
        );
      } else if (error instanceof ProjectNotFoundFault) {
        this.messenger.send(
          ToastMessage.create(
            new ProjectNotFoundMessage(this.project()),
            ToastLevel.Warning,
          ),
        );
      } else if (error instanceof ProgramNotFoundFault) {
        let program = this.programs().find((item) => item.id === error.programId);
        this.messenger.send(
          ToastMessage.create(
            new ProgramNotFoundMessage(program),
            ToastLevel.Warning,
          ),
        );
      }
    }
  };

  ngOnDestroy(): void {
    this.messenger.unsubscribeByOwner(this);
  }
}
